export const SHOWS_SECTION_CAT_ITEMS_ACTION = 'SHOWS_SECTION_CAT_ITEMS_ACTION';
export const SHOWS_SECTION_CAT_ITEMS_SUCCESS_ACTION =
  'SHOWS_SECTION_CAT_ITEMS_SUCCESS_ACTION';
export const SHOWS_SECTION_CAT_ITEMS_FAILURE_ACTION =
  'SHOWS_SECTION_CAT_ITEMS_FAILURE_ACTION';
export const SHOWS_SECTION_CAT_ITEMS_RESET_ACTION =
  'SHOWS_SECTION_CAT_ITEMS_RESET_ACTION';